


































































import { Component } from 'vue-property-decorator';
import * as api from '@/api';
import { PaginationMixin } from '@/utils/mixin';
import { SpaceUserRole } from '@/config/map.conf';
import AddSpaceAdmin from '../components/add-space-admin.vue';

/**
 * rg成员列表
 *
 * @author xiaokunyu
 * @date 01/11/2019
 */
@Component({
    components: {
        AddSpaceAdmin
    }
})
export default class SpaceDetailAdmin extends PaginationMixin {
    // @State(state => state.cti.permission.rg_user)
    permission: boolean = true;

    userList: CommonTypes.RgUserItem[] = [];
    addSpaceAdminVisible: Boolean = false;

    userRoleMap: CommonTypes.mapObject = SpaceUserRole;

    tableLoading: Boolean = true;
    $mtd: any;

    get spaceId() {
        return parseInt(this.$route.params.id, 10);
    }

    mounted() {
        this.getSpaceAdmin();
    }
    async getSpaceAdmin() {
        this.tableLoading = true;
        try {
            const res = await api.spaceApi.getSpaceAdmin(this.spaceId, {
                cn: this.currentPage,
                sn: this.limit
            });
            const { code, data } = res;
            if (code === 200) {
                this.userList = data.items;
                this.total = data.tn;
                if (this.total > 0 && !data.items.length) {
                    this.currentPage -= 1;
                    if (this.currentPage <= 0) {
                        this.currentPage = 1;
                    }
                    this.getSpaceAdmin();
                }
            }
            this.userList = res.data.items;
            this.total = res.data.tn;
        } catch (e) {
            this.userList = [];
            console.log(e);
        }
        this.tableLoading = false;
    }
    handleChange(current: number, size: number) {
        this.limit = size;
        this.currentPage = current;
        this.getSpaceAdmin();
    }
    // 删除rg成员
    handleDeleteRg(row) {
        const _this = this;
        this.$mtd
            .confirm({
                title: `你是否确认删除管理员：${row.username}？`,
                width: '433px',
                showCancelButton: true,
                type: 'warning',
                okButtonText: '删除',
                okButtonProps: {
                    type: 'danger'
                },
                onOk: async () => {
                    try {
                        await api.spaceApi.deleteSpaceAdmin(this.spaceId, row.username);
                        this.$mtd.message({
                            message: '删除成功',
                            type: 'success'
                        });
                        await _this.getSpaceAdmin();
                    } catch (e) {
                        console.log(e);
                    }
                }
            })
            .catch(e => e);
    }
    handleAddUser() {
        this.addSpaceAdminVisible = true;
    }
    // 设置成员组织架构信息
    setDept(bg: string, bu: string, org: string) {
        let dept: string = '';
        if (bg) {
            dept += `${bg}/`;
        }
        if (bu) {
            dept += `${bu}/`;
        }
        if (org) {
            dept += `${org}`;
        }
        return dept;
    }
    formatOrg(org) {
        const orgArr = (org && org.split('-')) || [];
        if (orgArr[0] === 'IPH') {
            orgArr.shift();
        }
        return orgArr.join('/');
    }
}
